import styled from 'styled-components'
import { PromoSection } from './WalletPromo/styles'
import { BenefitsSection } from './WalletBenefits/styles'
import { CarouselSection } from './WalletCarousel/styles'
import { AppSection } from './WalletApp/styles'

export const WalletSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  padding: 50px 10px 0;
  max-width: 1428px;
  width: 100%;
  min-height: 100vh;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 28px 10px;
    gap: 20px;

    & > ${PromoSection} {
      order: -2;
    }
    & > ${CarouselSection} {
      order: -1;
    }
  `}
`
